import { c as _c } from "react/compiler-runtime";
export const MoreIcon = t0 => {
  const $ = _c(11);
  const {
    selected
  } = t0;
  const fillColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.5" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] !== fillColor) {
    t3 = <path d="M22.25 20C22.25 20.9665 21.4665 21.75 20.5 21.75C19.5335 21.75 18.75 20.9665 18.75 20C18.75 19.0335 19.5335 18.25 20.5 18.25C21.4665 18.25 22.25 19.0335 22.25 20Z" fill={fillColor} />;
    t4 = <path d="M29.25 20C29.25 20.9665 28.4665 21.75 27.5 21.75C26.5335 21.75 25.75 20.9665 25.75 20C25.75 19.0335 26.5335 18.25 27.5 18.25C28.4665 18.25 29.25 19.0335 29.25 20Z" fill={fillColor} />;
    t5 = <path d="M15.25 20C15.25 20.9665 14.4665 21.75 13.5 21.75C12.5335 21.75 11.75 20.9665 11.75 20C11.75 19.0335 12.5335 18.25 13.5 18.25C14.4665 18.25 15.25 19.0335 15.25 20Z" fill={fillColor} />;
    $[2] = fillColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}</svg>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};